import { render, staticRenderFns } from "./orderCheck.vue?vue&type=template&id=451f281d&scoped=true&"
import script from "./orderCheck.vue?vue&type=script&lang=js&"
export * from "./orderCheck.vue?vue&type=script&lang=js&"
import style0 from "./orderCheck.vue?vue&type=style&index=0&id=451f281d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f281d",
  null
  
)

export default component.exports